require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/array/from.js
// module id = 637
// module chunks = 0